<app-alert></app-alert>

<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Allottees List</strong>
    </span>
    <span style="float:right">
      <button type="button" class="btn btn-sm btn-primary" (click)="loadncdAllotteesByID(null, 'createNew');">
        <i class="fa fa-plus"></i> Create New Allottee</button>

      <!-- <a routerLink="/ncd-allottees/add">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button">
          <i class="fa fa-plus"></i>Create New Allottee</button>
      </a> -->
    </span>
  </div>

  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
      <span class="pull-right">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </span>
    </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <form>
            <div class="row" style="margin-bottom: 10px;">
             
              <div class="col-sm-2">
                <label class="form-control-label">Investor Code :</label>
                <div class="input-group">
                  <select class="form-control" id="financialYr" style="padding:6px;" name="investorCode" [(ngModel)]="investorCodeModel">
                    <option value="">Select</option>
                    <option *ngFor="let investorCode of existingAllotteesInvestorCodeList" value="{{investorCode.investorCode}}">{{investorCode.investorCode}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Name :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="nameModel"
                    name="name" />
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Investor Category :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="investorCategoryModel"
                    name="investorCategory" />
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Investor Subcategory :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="investorSubcategoryModel"
                    name="investorSubCategory" />
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">DP Type :</label>
                <div class="input-group">
                  <select class="form-control" id="dpType" style="padding:6px;" name="dpType" [(ngModel)]="dpTypeModel">
                    <option value="">Select</option>
                    <option *ngFor="let dpType of dpTypeList" value="{{dpType}}">{{dpType}}
                    </option>
                  </select>
                </div>
              </div>

              
              <div class="col-sm-2">
                <label class="form-control-label">DP Id :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="dpIdModel"
                    name="dpId" />
                </div>
              </div>


              <div class="col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>Clear</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <!-- <pre> {{termsheetArray  | json  }} </pre>
           

                <span *ngFor="let termsheet of termsheetArray; let j = index;" style="width:125.4px">{{termsheet | json }}</span> -->

            <table datatable [dtOptions]="dtAllotteesList" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" id="allotteesListTable"
              style="cursor: pointer;">
              <thead>
                <!-- <tr>
                  <th style="width:125.4px">Investor Code</th>
                  <th style="width:76.2px">Name</th>
                  <th style="width:200.4px">Email</th>
                  <th style="width:193.2px">Investor Category</th>
                  <th style="width:125.4px">Investor Subcategory</th>
                  <th style="width:125.4px">Payin Amount</th>
                  <th style="width:125.4px">Payout Quantity</th>
                  <th style="width:125.4px">DP Type</th>
                  <th style="width:125.4px">DP Id</th>
                  <th style="width:125.4px">Ben/Cli Id</th>
                  <th style="width:125.4px;"><span>Action</span></th>
                </tr> -->
                <tr>
                  <th>Sr No</th>
                  <th>Investor Code</th>
                  <th>Name</th>
                  <th>Address Line 1</th>
                  <th>Line 2</th>
                  <th>Line 3</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Pincode</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>PAN</th>
                  <th>Investor Category</th>
                  <th>Investor Subcategory</th>
                  <th>Bank Name</th>
                  <th>IFSC</th>
                  <th>Virtual Account No</th>
                  <th>Payin Amount</th>
                  <th>Payout Quantity</th>
                  <th>DP Type</th>
                  <th>DP Id</th>
                  <th>Ben/Cli Id</th>
                  <th><span>Action</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let allotteesList of ncdAllotteesList; let i = index;" style="line-height: 25px;">
                  <td tabindex="1">{{allotteesList.srNo}}</td>
                  <td tabindex="1">{{allotteesList.investorCode}}</td>
                  <td tabindex="1">{{allotteesList.name}}</td>
                  <td tabindex="1">{{allotteesList.addressLine1}}</td>
                  <td tabindex="1">{{allotteesList.addressLine2}}</td>
                  <td tabindex="1">{{allotteesList.addressLine3}}</td>
                  <td tabindex="1">{{allotteesList.city}}</td>
                  <td tabindex="1">{{allotteesList.state}}</td>
                  <td tabindex="1">{{allotteesList.country}}</td>
                  <td tabindex="1">{{allotteesList.pinCode}}</td>
                  <td tabindex="1">{{allotteesList.email}}</td>
                  <td tabindex="1">{{allotteesList.mobile}}</td>
                  <td tabindex="1">{{allotteesList.PAN}}</td>
                  <td tabindex="1">{{allotteesList.investorCategory}}</td>
                  <td tabindex="1">{{allotteesList.investorSubCategory}}</td>
                  <td tabindex="1">{{allotteesList.bankName}}</td>
                  <td tabindex="1">{{allotteesList.IFSC}}</td>
                  <td tabindex="1">{{allotteesList.virtualAccountNo}}</td>
                  <td tabindex="1">{{allotteesList.allotteesDynamicFieldsArray[0].payinAmount}}</td>
                  <td tabindex="1">{{allotteesList.allotteesDynamicFieldsArray[0].payoutQuantity}}</td>
                  <td tabindex="1">{{allotteesList.dpType}}</td>
                  <td tabindex="1">{{allotteesList.dpID}}</td>
                  <td tabindex="1">{{allotteesList.benCliId}}</td>
                  <td style='white-space: nowrap !important'>
                      <button type="button" class="btn-sm btn btn-warning" id="{{allotteesList._id}}" (click)="loadncdAllotteesByID(allotteesList._id, 'update')">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;
                    <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(allotteesList._id)">
                      <span class="icmn-bin"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="confirmDeleteAllottee" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Allottee?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteNcdIssueSpecificAllottees()" data-dismiss="modal">
            <i class="fa fa-check"></i>Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>No
          </button>
        </div>
      </div>
    </div>
  </div>




  <!-- Create New Allottee -->
  <!-- <div class="modal fade modal-size-large" id="allotteeModal" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="allotteeLabel">Allottee Details :
            </h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <app-allotees [issueDetails]="issueDetails"></app-allotees>
         
      </div>
    </div>
  </div> -->

  <!-- Edit New Allottee -->
  <!-- <div class="modal fade modal-size-large" id="editAllotteeModal" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="allotteeLabel">Allottee Details :
            </h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <app-allotees [allotteeId]="allotteeId"></app-allotees>
         
      </div>
    </div>
  </div> -->
</section>